import BaseAPI from './base';
import type { OrderFilterOption as FilterCategory } from '../../types/entity/order-filter';

// FilterCategoryAPI 筛选类别通用服务（仅列表/CRUD）
export class FilterCategoryAPI extends BaseAPI<FilterCategory> {
  constructor() {
    super('/filter-categories');
  }
}

export const filterCategoryApi = new FilterCategoryAPI();
